import axiosInstance from "../utils/axiosInstance";
import { URLS } from "../utils/baseUrls";

const toLocalIsoSeconds = (value) => {
  const sourceDate = value ? new Date(value) : new Date();

  if (Number.isNaN(sourceDate.getTime())) {
    throw new Error("Invalid date value for alerts prediction");
  }

  const year = sourceDate.getFullYear();
  const month = `${sourceDate.getMonth() + 1}`.padStart(2, "0");
  const day = `${sourceDate.getDate()}`.padStart(2, "0");
  const hours = `${sourceDate.getHours()}`.padStart(2, "0");
  const minutes = `${sourceDate.getMinutes()}`.padStart(2, "0");
  const seconds = `${sourceDate.getSeconds()}`.padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};

const predictInsectAlerts = async ({ cropId, fieldId, date } = {}) => {
  const payload = {
    crop_id: cropId,
    date: toLocalIsoSeconds(date),
    field_id: fieldId,
  };

  const response = await axiosInstance.post(
    `${URLS.statisticsV2}/insect-alerts/predict/`,
    payload,
  );

  return response;
};

const predictStressAlerts = async ({ cropId, fieldId, date } = {}) => {
  const payload = {
    crop_id: cropId,
    date: toLocalIsoSeconds(date),
    field_id: fieldId,
  };

  const response = await axiosInstance.post(
    `${URLS.statisticsV2}/stress-alerts/predict/`,
    payload,
  );

  return response;
};

const predictActionAlerts = async ({ cropId, fieldId, date } = {}) => {
  const payload = {
    crop_id: cropId,
    time: toLocalIsoSeconds(date),
    field_id: fieldId,
  };

  const response = await axiosInstance.post(
    `${URLS.statisticsV2}/action-alerts/predict/`,
    payload,
  );

  return response;
};

const predictWeatherAlerts = async ({ fieldId, startDate } = {}) => {
  const params = new URLSearchParams({ field_id: fieldId });
  if (startDate) params.set("start_date", startDate);

  const response = await axiosInstance.get(
    `${URLS.externalRequests}/weather-api/emy/alerts/predict/?${params}`,
  );

  return response;
};

const predictIrrigationNeedAlerts = async ({ fieldIds = [], days } = {}) => {
  const params = new URLSearchParams();
  fieldIds
    .filter((fieldId) => fieldId !== null && fieldId !== undefined)
    .forEach((fieldId) => params.append("field_id", fieldId));
  if (days !== null && days !== undefined) params.set("days", days);

  const response = await axiosInstance.get(
    `${URLS.statisticsV2}/irrigation-need/predict/?${params}`,
  );

  return response;
};

export const alertsApi = {
  insectAlerts: {
    predict: predictInsectAlerts,
  },
  stressAlerts: {
    predict: predictStressAlerts,
  },
  actionAlerts: {
    predict: predictActionAlerts,
  },
  weatherAlerts: {
    predict: predictWeatherAlerts,
  },
  irrigationNeedAlerts: {
    predict: predictIrrigationNeedAlerts,
  },
};
